import { Controller } from '@hotwired/stimulus';
import { buildTabSelector, updateSidebarActiveState } from '../constants/undistractor_tabs';

// Handles sidebar links that should switch tabs without page reload when already on the target page
export default class extends Controller {
  static values = { tab: String, basePath: String, url: String };

  click(event) {
    if (!window.location.pathname.startsWith(this.basePathValue)) return;

    // Ensure we don't hijack links to undistractor_settings tabs if we're on an undistractor_settings page that doesn't have all undistractor_settings tabs loaded
    const tabBtn = document.querySelector(buildTabSelector(this.tabValue));
    if (!tabBtn) return;

    event.preventDefault();

    updateSidebarActiveState(this.tabValue);

    history.pushState({}, '', this.urlValue);

    tabBtn.click();
  }
}
